<template>
  <v-row class="pa-5">
    <!-- Basic Grooming -->
    <v-col cols="12" md="6">
      <h4>Basic Grooming</h4>
      <v-select
        v-model="BasicGroomingNumSmallBreeds"
        :items="['None','1 kid', '2 kids', '3 or more']"
        label="Small Breed"
      ></v-select>
      <v-select
        v-model="BasicGroomingNumMediumBreeds"
        :items="['None','1 kid', '2 kids', '3 or more']"
        label="Medium Breed"
      ></v-select>
      <v-select
        v-model="BasicGroomingNumLargeBreeds"
        :items="['None','1 kid', '2 kids', '3 or more']"
        label="Large Breed"
      ></v-select>
    </v-col>

    <!-- Full Grooming -->
    <v-col cols="12" md="6">
      <h4>Full Grooming</h4>
      <v-select
        v-model="FullGroomingNumSmallBreeds"
        :items="['None','1 kid', '2 kids', '3 or more']"
        label="Small Breed"
      ></v-select>
      <v-select
        v-model="FullGroomingNumMediumBreeds"
        :items="['None','1 kid', '2 kids', '3 or more']"
        label="Medium Breed"
      ></v-select>
      <v-select
        v-model="FullGroomingNumLargeBreeds"
        :items="['None','1 kid', '2 kids', '3 or more']"
        label="Large Breed"
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    BasicGroomingNumSmallBreeds: "",
    BasicGroomingNumMediumBreeds: "",
    BasicGroomingNumLargeBreeds: "",
    FullGroomingNumSmallBreeds: "",
    FullGroomingNumMediumBreeds: "",
    FullGroomingNumLargeBreeds: ""
  }),
  watch: {
    BasicGroomingNumSmallBreeds: function(val) {
      this.$emit("change", "BasicGroomingNumSmallBreeds", val);
    },
    BasicGroomingNumMediumBreeds: function(val) {
      this.$emit("change", "BasicGroomingNumMediumBreeds", val);
    },
    BasicGroomingNumLargeBreeds: function(val) {
      this.$emit("change", "BasicGroomingNumLargeBreeds", val);
    },
    FullGroomingNumSmallBreeds: function(val) {
      this.$emit("change", "FullGroomingNumSmallBreeds", val);
    },
    FullGroomingNumMediumBreeds: function(val) {
      this.$emit("change", "FullGroomingNumMediumBreeds", val);
    },
    FullGroomingNumLargeBreeds: function(val) {
      this.$emit("change", "FullGroomingNumLargeBreeds", val);
    }
  }
};
</script>